import { gql } from '@apollo/client';
import { SIMPLR_ACCOUNT_FIELDS_FRAGMENT } from './simplrAccountFieldsFragment.gql';

export const GET_DISCOUNT_PERIODS_FOR_ACCOUNT_QUERY = gql`
  query getDiscountPeriodsForAccount($filter: DiscountPeriodFilter) {
    discountPeriodsFind(filter: $filter) {
      nodes {
        objectId: id
        createdAt
        updatedAt
        status
        title
        discountType
        discountQualificationInstructions
        couponCode
        discountDescription
        discount
        discountPeriodStartDate
        discountPeriodEndDate
        gracePeriodStartDate
        gracePeriodEndDate
        expirationDate
        simplrAccountId
      }
    }
  }
`;

export const FIND_COUPON_CODE_TYPES_QUERY = gql`
  query findCouponCodeTypes($filter: CouponCodeTypeFilter) {
    couponCodeTypesFind(filter: $filter) {
      nodes {
        objectId: id
        createdAt
        updatedAt
        name
        maxSends
        isDecisionTreeCoupon
        simplrAccountId
        simplrAccountPtr {
          objectId: id
        }
      }
    }
  }
`;

export const FIND_BUSINESS_DETAILS_QUERY = gql`
  ${SIMPLR_ACCOUNT_FIELDS_FRAGMENT}
  query findBusinessDetails(
    $paging: CursorPaging
    $sorting: [BusinessDetailSort!]
    $filter: BusinessDetailFilter
    $isAdmin: Boolean!
  ) {
    businessDetailsFind(paging: $paging, sorting: $sorting, filter: $filter) {
      pageInfo {
        cursor: endCursor
      }
      nodes {
        objectId: id
        createdAt
        updatedAt
        description
        knowledgeBaseFolderUrl
        smbName
        homepageUrl
        businessLogoUrl
        historicalTicketSearch
        ticketSystem
        accountStatus
        nameToCustomer
        responseGuideUrl
        accountType
        blacklistedSubjectText
        blacklistWords
        subBusinessVerticals
        blacklistedBodyText
        blacklistedEmailIds
        decisionTreeDrafts
        partnerInfo
        blacklistedChannelEmailAddress
        avgTicketNumber
        simplrTagOnTake
        showOrderPrefix
        useDiscountApplications
        simplrCategories
        extraBusinessInfo
        decisionTree
        blacklistRegexes
        customMacros
        decisionTreeOverrides
        ticketsSearchConfig
        brandOptions
        homepageUrls
        autoResponseConfig
        autoResponsePassiveConfig
        tagsConfig
        conversationalCommerce
        autoResponseValidationConfig
        dummyButtonActions
        languageOptions
        simplrAccountId
        simplrAccountPtr @include(if: $isAdmin) {
          ...SimplrAccountFields
        }
        demoClientId
        flowDebugStateFavoriteFieldsList
      }
    }
  }
`;

export const FIND_BRAINTRUST_PLATFORM_CONFIG_QUERY = gql`
  query PlatformConfigFindFirst($filter: PlatformConfigFilter) {
    platformConfigFindFirst(filter: $filter) {
      id
      braintrustConfig
      braintrustDomain
    }
  }
`;
